export * from './dropdown/search-filter.pipe';
export * from './dropdown/dropdown.module';
export * from './dropdown/dropdown.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/~/angular-2-dropdown-multiselect/index.js
// module id = ../../../../angular-2-dropdown-multiselect/index.js
// module chunks = 4